export default {
  apiEndpoint: process.env.REACT_APP_API_URL || process.env.API_URL || 'https://api-defaultd.develop.shootsta.com/',
  sentryDSN: '',
  sentryReleasePrefix: 'dev@'
};
